const restaurantSelector = ({ restaurant }) => restaurant;

export default restaurantSelector;
